import jsonLogic, { type RulesLogic } from 'json-logic-js';
import { getAllFeatureFlags } from './feature-flags-storage';

/**
 * Evaluates whether AI assist should be shown for a given control.
 *
 * When `includeIf` rules are provided (from the schema's `aiAssist.includeIf`),
 * they are evaluated against the current feature flag state using the same
 * `_featureFlags` convention as `x-entity-conditional`.
 *
 * When no rules are provided, returns `true` (the control is unconditionally included).
 */
export const isAiAssistEnabled = (includeIf?: RulesLogic): boolean => {
  if (!includeIf) return true;
  return Boolean(
    jsonLogic.apply(includeIf, { _featureFlags: getAllFeatureFlags() }),
  );
};
